module.exports = __webpack_public_path__ + "img/CM-AB-24-INFINITI-Established.4fa0030a.jpg";